module.exports = __webpack_public_path__ + "img/dollar.8dcc615c.svg";